import UploadPlaceholderImage from 'src/assets/img/upload-placeholder.svg';
import Button from '@ui/components/Button/Button';
import useFeatureFlag from 'src/new_arch/modules/featureFlags/hooks/useFeatureFlag';
import WatchFolderButton from '../../WatchFolderButton/WatchFolderButton';

import styles from './EmptyPlaceholder.module.scss';

type EmptyPlaceholderProps = {
	canUploadItems: boolean;
	isFolderSyncSupported?: boolean;
	onStartUploadClick?: () => void;
	onWatchFolderClick?: () => void;
};

const EmptyPlaceholder = ( {
	canUploadItems,
	isFolderSyncSupported,
	onStartUploadClick,
	onWatchFolderClick
}: EmptyPlaceholderProps ) => {
	const isWatchFoldersEnabled = useFeatureFlag( 'watchFoldersEnabled' )

	return (
		<div className={styles.EmptyPlaceholder}>
			<div className={styles.EmptyPlaceholder__content}>
				<img
					className="download-icon"
					src={UploadPlaceholderImage}
					alt="download icon"
				/>
				<div className={styles.EmptyPlaceholder__details}>
					{canUploadItems ? (
						<>
							<p>Drag and drop files on the screen</p>
							<p>or</p>
							<Button
								size="sm"
								onClick={onStartUploadClick}
							>
								Start Upload
							</Button>
							{isFolderSyncSupported && isWatchFoldersEnabled && (
								<WatchFolderButton variant="outline" onClick={onWatchFolderClick!} />
							)}
						</>
					) : (
						<>
							<p>No uploads yet</p>
							<p>Start adding assets to your projects to see them displayed here.</p>
						</>
					)}
				</div>
			</div>
		</div>
	)
};

export default EmptyPlaceholder;
